import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker as MuiDateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DATETIME_FORMAT } from "../../helpers/time";

type Props = {
  value: string;
  className: string;
  label: string;
  fullWidth: boolean;
  error: string;
  helperText: string;
  onChange: (value: string) => any;
  onSubmit?: () => void;
  onCancel?: () => void;
  variant?: "standard" | "outlined" | "filled"; // default: outlined
} & any;

function DateTimePicker({
  value,
  className,
  label,
  fullWidth,
  error,
  helperText,
  onSubmit,
  onCancel,
  onChange,
  variant,
  ...restProps
}: Props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDateTimePicker
        label={label}
        ampm={false}
        format={DATETIME_FORMAT}
        className={className}
        onChange={(value: Dayjs) => {
          if (value) {
            const dtstr = value.format(DATETIME_FORMAT); //@TODO: refactor to replace moment with dayjs
            onChange(dtstr);
          }
        }}
        onSubmit={onSubmit}
        onCancel={onCancel}
        style={{ width: fullWidth && "100%" }}
        value={(value && dayjs(value, DATETIME_FORMAT)) || null}
        slotProps={{
          textField: { variant, error, helperText },
        }}
        {...restProps}
      />
    </LocalizationProvider>
  );
}

export default DateTimePicker;
